import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { AutoCompleteDataModel } from 'components/MprcAutoComplete';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MemberAutoComplete } from 'views/foundation/member/components/MemberAutoComplete';
import { IAdvFilterPickerProps } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const MemberPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <MemberAutoComplete
                    autoFocus
                    placeholder={t(`AdvFilter.Picker.Member.Placeholder${multiSelect ? "_multi" : ""}`)}
                    multiSelect={multiSelect}
                    selectedItems={selected}
                    onChange={(items) => setSelected(items)}
                    onError={MprcRequestSnackbarErrorReport}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
